<template>
	<div class="main-contents">
		<!-- 이력서 등록대행 -->
		<div class="mem_container">
			<div class="mem_contents_body">
				<div class="resmAgnc">
					<div class="box blue">
						<img src="/images/resume_01.png">
					</div>
					<div class="box default imgBtn">
						<img src="/images/resume_02_start_btn.png" @click="goStart">
					</div>
					<div class="box default">
						<img src="/images/resume_start_text.png">
					</div>
					<div class="box resmPtn">
						<img src="/images/resume_04_banner.png">
					</div>
					<div class="box blue" ref="kakaoStart">
						<img src="/images/resume_05.png">
					</div>
					<div class="box default">
						<img src="/images/resume_06.png">
					</div>
					<div class="box kakaoSync imgBtn">
						<img src="/images/kakao_sync_btn_02.png" @click="goKakao">
					</div>
					<div class="box default">
						<img src="/images/kakao_sync_text.png">
					</div>
					<div class="box fileUpload imgBtn" ref="uploadArea">
						<img src="/images/file_upload_btn_02.png" @click="atchFile">
						<span class="fileName" v-if="fileName">파일명 :<nbsp n="5"/>{{fileName}}</span>
					</div>
					<div class="box default">
						<img src="/images/file_upload_text.png">
					</div>

					<div id="fileArea" style="display: none;">
						<file-select type="file" v-model="temp.resmFile" :accept="fileAcpt" @input="resmFileUpload"/>
					</div>
				</div>
				
			</div>
		</div><!-- //mem_container -->
	</div><!-- //main-contents -->
</template>

<script>
import fileSelect from "@/components/FileSelect.vue";
export default {
	components: { fileSelect },
	data() {
		return {
			fileAcpt: '.xlsx,.xls,doc,.docx,.pdf',
			
			temp:{},
			code:'',

			fileName:'',
			fileSeq:'',

			isLogin: false,
			mberInfo:{},
			userDstic:'',
			stipReChk:{},
		};
	},
	mounted() {
		var tokenData = window.sessionStorage.getItem('user_token');

		if(tokenData != null) {
			tokenData = JSON.parse(tokenData);
			
			if(tokenData.token) {
				this.isLogin = true;
				
				if(this.$route.query.loginDstic == 'kakao') {
					setTimeout(() => {
						this.$.focus(this.$refs.uploadArea);
					}, 100);
				}

				var userInfo = window.sessionStorage.getItem('user_info');
				userInfo = JSON.parse(userInfo);
				this.findAttaFileName(userInfo.mberSeq);

				setTimeout(() => {
					if(this.$route.query.userDstic == '') {
						this.recmmRegiPup();
					}
				}, 100);

				// var userInfo = window.sessionStorage.getItem('user_info');
				// userInfo = JSON.parse(userInfo);
				// this.findAttaFileName(userInfo.mberSeq);
			}

		}
	},
	methods: {
		atchFile() {
			if(!this.isLogin) {
				alert('로그인 후 이용해 주세요.');
				return;
			}

			var btnElm = this.$el.querySelector('.fileSelect > input[type=file]');
			btnElm.click();
		},
		resmFileUpload(file){
			if(confirm('"'+file.name+'" 파일을 업로드하시겠습니까?')) {
                this.$.fileUpload('IMG_PDF_DOC', [file], '/api/mem/prf/uploadResmAgncFile')
                    .then(() => {
						this.fileName = file.name;
					})
					.catch(err => {
					    this.temp.resmFile = null;
                    	this.$.httpErrorCommon(err);
					});
            } else {
                this.temp.resmFile = null;
            }
		},
		goStart() {
			this.$.focus(this.$refs.kakaoStart);
		},
		goKakao() {
			if(this.isLogin) {
				alert('이미 로그인 되어 있습니다.');
				return;
			}

			this.$.kakaoSync(this, function(this_obj, res) {
				this_obj.code = res;
				this_obj.accountSync();
			});
		},
		accountSync() {
			this.$.httpPost('/api/mem/kakao/accountSync', {code : this.code})
				.then(res => {
					this.userDstic = res.data.userDstic;

					if(this.userDstic == 'SYNC' || this.userDstic == 'LOGIN') {
						this.login(res.data.mberSeq);
					}else {
						this.mberInfo = res.data.mberInfo;
						this.openStipPup(); // 2차 동의 팝업
					}
					
				}).catch((err) => {
					var errResData = err.response.data;
					
					if(errResData && errResData.error_description != '')  {
						alert(errResData.error_description);
					}
				});
		},
		login(mberSeq) {
			this.$.loginKakao(mberSeq, 'kakaoSync')
				.then(() => {
					location.href = location.origin + '/MEM001M02?loginDstic=kakao&userDstic='+this.userDstic;
				})
				.catch(this.$.httpErrorCommon);
		},
		findAttaFileName(mberSeq) {
			this.$.httpPost('/api/mem/getRegiAgncFileName', {mberSeq})
				.then(res => {
					this.fileSeq = res.data.attFileSeq;
					this.fileName = res.data.fileName;
				}).catch((err) => {
					var errResData = err.response.data;
					
					if(errResData && errResData.error_description != '')  {
						alert(errResData.error_description);
					}
				});
		},
		openStipPup() {
			this.$.popup('/mem/MEM001P04')
				.then(res => {
					if(res) {
						var tempStip = {
							agreeYn: res.stipReChk.agreeYn ? 'Y' : 'N',
							stipDivCd: res.stipReChk.stipDivCd
						};

						this.mberInfo.stipList.push(tempStip);

						this.saveMember();
					}
				})

			
			// this.$.stipReChkPup(this, function(this_obj, res) {
			// 	this_obj.stipReChk = res.stipReChk;
			// 	this_obj.stipCallback();
			// });
		},
		saveMember() {
			this.$.httpPost('/api/mem/insertMberInfo', {mberInfo: this.mberInfo}, '')
				.then(res => {
					if(res.data.resultCode == "000"){
						if(res.data.data.mberSeq) {
							this.login(res.data.data.mberSeq);
						}
					}else {
						alert(res.data.message);
					}
				})
				.catch(err => {
					alert(err.response.data.error_description);
				});
		},
		recmmRegiPup() {
			this.$.popup('/mem/MEM001P05')
				.then(res => {
					if(res) {
						this.regiRecmmder(res.recmmderHpNo);
					}else {
						history.replaceState({}, null, location.pathname);
					}
				});

			// this.$.recommderPup(this, function(this_obj, res) {
			// 	this_obj.regiRecmmder(res.recmmderHpNo);
			// });
		},
		regiRecmmder(recmmderHpNo) {
			this.$.httpPost('/api/mem/updateMberInfo', {mberInfo: {recmmderHpNo, mberSeq: this.$store.state.userInfo.mberSeq}})
				.then(res => {
					if(res.data.resultCode == "000"){
						alert("추천인 등록이 완료되었습니다.");
						history.replaceState({}, null, location.pathname);
					}else {
						alert(res.data.message);
					}
				})
				.catch(err => {
					alert(err.response.data.error_description);
				});
		},
		openPup(scrnNm) {
			if(scrnNm == 'MEM001P04') {
				this.$.stipReChkPup(this, function(this_obj, res) {
					this_obj.stipReChk = res.stipReChk;
					this_obj.stipCallback();
				});
			}else {
				// console.log(scrnNm);
			}
		},
		stipCallback() {
			var tempStip = {
				agreeYn: this.stipReChk.agreeYn ? 'Y' : 'N',
				stipDivCd: this.stipReChk.stipDivCd
			};

			this.mberInfo.stipList.push(tempStip);

			this.saveMember();
		}
	},
}
</script>
